import type { Types } from '../types';
import type { OutTypes } from './schedules';
import { getVertexId } from '../util';
import { omitEdgesAndInternalProperties, type SerializedEdgesOnlyVertexExport, type SerializedEdgesShape } from './util';
import type { BaseOptions } from '../../common/types';
import type { LinkedEventsSetVertex } from '../interfaces/vertices/linked-events-sets';


export default (
  linkedEventsSets: Types.Mixed.LinkedEventsSet[],
  options:          BaseOptions
): OutTypes.linkedEventsSet[] => {
  return linkedEventsSets
    .map(x => {
      const edges: SerializedEdgesOnlyVertexExport<LinkedEventsSetVertex> = {
        events: x.events?.map(x => getVertexId(x, options)),
      } satisfies SerializedEdgesShape<SerializedEdgesOnlyVertexExport<LinkedEventsSetVertex>>;
      const nonEdges = omitEdgesAndInternalProperties(x, edges);

      return { ...nonEdges, ...edges };
    });
}